import TemplateMain from '../templateMain'
import fridge from '../../image/404Refrigerator.jpg'
import { SLIDESHOWS } from '../../types'
const InnerPageNotFound404 = () => {
  return (
    <div style={{ textAlign: 'center' }}>
      <img src={fridge} />
    </div>
  )
}

export default function NotFound404() {
  return (
    <TemplateMain
      g_section=""
      htmlTitle="404 Page Not Found"
      linksTitle="Other Site Links"
      innerPage={<InnerPageNotFound404 />}
      g_sidebarKey="pageHome"
      g_slideshowKey={SLIDESHOWS.logos}
    />
  )
}
